import {Component, Inject, isDevMode, OnDestroy, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {DatePipe} from "@angular/common"
import firebase from "firebase/compat/app";
import Timestamp = firebase.firestore.Timestamp;
import {environment} from "../../../../../environments/environment";
import {UploadModel} from "../../../../models/UploadModel";
import {Observable, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {AngularFireStorage} from "@angular/fire/compat/storage";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {MatSnackBar} from "@angular/material/snack-bar";
import {needConfirmation} from "../../../../confirm-dialog/confirm-dialog.decorator";
import {ɵFormGroupRawValue, ɵGetProperty, ɵTypedOrUntyped} from "@angular/forms";


@Component({
  selector: 'app-view-education-individual',
  templateUrl: './view-education-individual.component.html',
  styleUrls: ['./view-education-individual.component.scss']
})
export class ViewEducationIndividualComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();
  // mDbType:'realtime'|'firestore'='firestore';
  // mStoragePath?: string ='education/view-education-individual'
  // mPath='educationTest/';
  env = isDevMode() ? environment.testMode : environment.productionMode
  mDocuments:UploadModel[]=[]
  mDbType: 'realtime' | 'firestore' = 'firestore';
  mStoragePath?: string = 'education/individual-sessions'
  mPath = 'Education';
  documents$: Observable<unknown | undefined>
  private languagePercentage=0;
  private evsgkPercentage=0;
  private mathsPercentage=0;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              private readonly datePipe: DatePipe,
              private readonly mStorage:AngularFireStorage,
              private readonly mFirestore:AngularFirestore,
              private readonly _snackBar:MatSnackBar,)


  {
    console.log(data)
    this.mStoragePath = this.mStoragePath +'/' + data.id
    console.log(`Document will be uploaded to ${this.mStoragePath} on ${this.mDbType} in ${this.mPath} `)
    console.log(data)
    this.mStoragePath = this.mStoragePath + '/' + data.id
    this.mPath =this.env.documents+'/'+ this.mPath + '/individualSessions/' + data.id
    console.log(`Document will be uploaded to ${this.mStoragePath} on ${this.mDbType} in ${this.mPath} `)

    // Stamp root-level metadata so the photo gallery can query by date & centre
    const sessionDate = data.sessionDate || data.date || null;
    this.mFirestore.doc(this.mPath).set({
      date:        sessionDate,
      dateAdded:   sessionDate,
      centreCode:  data.centreCode  || '',
      centreName:  data.centreName  || '',
    }, { merge: true });

    this.documents$  = this.mFirestore.doc( this.mPath).valueChanges({idField:'id'})
    this.documents$.pipe(takeUntil(this._destroyed$)).subscribe(res=>{
      // @ts-ignore
      this.mDocuments = res.documents as UploadModel
    })
  }



  ngOnInit(): void {
  }
    getDate(date: Date):any {
      let d = (date as unknown as Timestamp).toDate()
      let datePipeString = this.datePipe.transform(d,'dd-MMM-yyyy');
      return datePipeString
    }


  // getTime(date: string):any {
  //   let d = (date as unknown as Timestamp).toDate()
  //   let datePipeString = this.datePipe.transform(d,"HH:mm:aa");
  //   return datePipeString
  // }

  getTopicsCovered(centres:any[]):string{
    let str=''
    centres.forEach(it=>{
      str += it+', '
    })
    return str
  }

  getTime(startTime: number | DOMHighResTimeStamp | CSSNumberish | undefined) {
    let d = (startTime as unknown as Timestamp).toDate()
      let datePipeString = this.datePipe.transform(d,"h:mm:a");
      return datePipeString
  }
  getTime2(date: Date):any {
    let datePipeString: string | null = "NA"

    if (date!=null){
      let d = (date as unknown as Timestamp).toDate()
      datePipeString = this.datePipe.transform(d,"h:mm a")
      // console.log('DATEPIPE STRING',datePipeString )

      return datePipeString
    }
  }

  trackByMethod(index: number, el: any): number {
    return el.id;
  }

  openLink(fileUrl: string) {
    window.open(fileUrl)

  }

  @needConfirmation()
  deleteAdmissionFile(i: number, d: UploadModel, category: string) {
    const iRef = this.mStorage.storage.refFromURL(d.url)
    iRef.delete().then(() => {
      this.mFirestore.doc(this.mPath).update({
        [category]: firebase.firestore.FieldValue.arrayRemove(d)
      }).then(() => {
        this._snackBar.open('File Deleted Successfully')._dismissAfter(2000)
      })
    })
    console.log(iRef)
  }

  getLanguagePercentage(value1: any, value2: any) {
    if (value1 != null && value2 != null) {
      const maxMarks = this.data?.sessionType === "Intermediate Assessment" ? 10 : 20;
      this.languagePercentage = limitDecimalPlaces(
        (((value1 / maxMarks) + (value2 / maxMarks)) * 100),
        2
      );
      return this.languagePercentage;
    }
    return 0;
  }

  getMathsPercentage(value1: any, value2: any) {
    if (value1 != null && value2 != null) {
      const maxMarks = this.data?.sessionType === "Intermediate Assessment" ? 10 : 20;
      this.mathsPercentage = limitDecimalPlaces(
        (((value1 / maxMarks) + (value2 / maxMarks)) * 100),
        2
      );
      return this.mathsPercentage;
    }
    return 0;
  }

  getEvsGKPercentage(value1: any, value2: any) {
    if (value1 != null && value2 != null) {
      const maxMarks = this.data?.sessionType === "Intermediate Assessment" ? 10 : 20;
      this.evsgkPercentage = limitDecimalPlaces(
        (((value1 / maxMarks) + (value2 / maxMarks)) * 100),
        2
      );
      return this.evsgkPercentage;
    }
    return 0;
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

}
function limitDecimalPlaces(value: number, maxDecimalPlaces: number): number {
  const parsedValue = parseFloat(value.toFixed(maxDecimalPlaces));
  return parsedValue;
}

